import { Checkbox } from '@dreamtree-org/twreact-ui';

/**
 * "What do you sell?" (MERCH-89): industries from the registry (GET /api/platform/apply/catalog), and, with
 * `withTypes`, the product types of each chosen industry. The server checks the same rules (lib/platform/industries
 * cleanSelection): every type within a chosen industry, every chosen industry with a type.
 *
 *   catalog     [{ key, label, types: [{ key, label, plural }] }]
 *   value       { industries: [key…], types: [key…] }
 *   onChange    (next value) → void; turning an industry off drops its types
 */
export default function SellPicker({ catalog = [], value, onChange, withTypes = false, disabled = false }) {
  const inds = value.industries || [];
  const types = value.types || [];
  const setIndustry = (ind, on) => {
    const dropped = new Set(on ? [] : (ind.types || []).map((t) => t.key));
    onChange({ industries: on ? [...new Set([...inds, ind.key])] : inds.filter((k) => k !== ind.key), types: types.filter((k) => !dropped.has(k)) });
  };
  const setType = (key, on) => onChange({ industries: inds, types: on ? [...new Set([...types, key])] : types.filter((k) => k !== key) });

  return (
    <div className="space-y-3">
      {catalog.map((ind) => {
        const chosen = inds.includes(ind.key);
        return (
          <div key={ind.key} className="rounded-lg border border-[var(--app-border)] px-3 py-2">
            <Checkbox label={ind.label} checked={chosen} disabled={disabled} onChange={(e) => setIndustry(ind, e.target.checked)} />
            {withTypes && chosen ? (
              <div className="mt-2 grid gap-1 pl-6 sm:grid-cols-2">
                {(ind.types || []).map((t) => (
                  <Checkbox key={t.key} size="sm" label={t.plural} checked={types.includes(t.key)} disabled={disabled} onChange={(e) => setType(t.key, e.target.checked)} />
                ))}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
